import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Calendar, Star, Activity, Clock } from "lucide-react";

const Home = () => {
  const users = useSelector((state) => state.user.currentUser);
  const { appointments } = useSelector((state) => state.appointments);

  const stats = [
    {
      label: "Total Appointments",
      value: appointments?.length ?? 0,
      icon: <Calendar size={22} />,
      colorClass: "blue",
      link: "/appointments/appointment-list",
    },
    {
      label: "Completed",
      value: appointments?.filter((a) => a.status === "completed").length ?? 0,
      icon: <Activity size={22} />,
      colorClass: "green",
    },
    {
      label: "Booked",
      value: appointments?.filter((a) => a.status === "booked").length ?? 0,
      icon: <Clock size={22} />,
      colorClass: "amber",
    },
    {
      label: "Cancelled",
      value: appointments?.filter((a) =>
        a.status === "cancelled" || a.status === "cancelledbyuser"
      ).length ?? 0,
      icon: <Star size={22} />,
      colorClass: "red",
    },
  ];

  const recent = appointments?.slice(0, 5) ?? [];

  const statusClass = (status = "") => {
    const s = status.toLowerCase().replace(/\s+/g, "");
    const map = {
      booked: "booked",
      paid: "paid",
      completed: "completed",
      cancelled: "cancelled",
      cancelledbyuser: "cancelledbyuser",
    };
    return map[s] || "booked";
  };

  return (
    <div>
      {/* Welcome banner */}
      <div className="welcome-banner">
        <h4>Welcome back, {users?.labName} 👋</h4>
        <p>Here's what's happening with your lab today.</p>
      </div>

      {/* Stat cards */}
      <div className="row g-3 mb-4">
        {stats.map((s) => (
          <div className="col-6 col-md-3" key={s.label}>
            <div className="stat-card">
              <div className={`stat-card-icon ${s.colorClass}`}>{s.icon}</div>
              <div className="stat-card-body">
                <h3>{s.value}</h3>
                <p>{s.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Recent appointments */}
      <div className="card">
        <div
          className="card-header d-flex align-items-center justify-content-between"
          style={{ padding: "1rem 1.25rem", borderBottom: "1px solid var(--gray-100)" }}
        >
          <h5 style={{ margin: 0, fontSize: "0.95rem", fontWeight: 600 }}>
            Recent Appointments
          </h5>
          <Link
            to="/appointments/appointment-list"
            style={{ fontSize: "0.8rem", color: "var(--primary)", fontWeight: 500 }}
          >
            View all →
          </Link>
        </div>

        {recent.length === 0 ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "var(--gray-400)" }}>
            <Calendar size={36} style={{ marginBottom: "0.75rem", opacity: 0.4 }} />
            <p style={{ color: "var(--gray-400) !important" }}>No appointments yet</p>
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table className="table table-hover" style={{ marginBottom: 0 }}>
              <thead>
                <tr>
                  <th className="table-header">#</th>
                  <th className="table-header">Patient</th>
                  <th className="table-header">Test</th>
                  <th className="table-header">Date</th>
                  <th className="table-header">Status</th>
                  <th className="table-header"></th>
                </tr>
              </thead>
              <tbody>
                {recent.map((a, i) => (
                  <tr key={a._id}>
                    <td style={{ color: "var(--gray-400)", fontSize: "0.8rem" }}>{i + 1}</td>
                    <td style={{ fontWeight: 500 }}>{a.appointerName}</td>
                    <td style={{ color: "var(--gray-500)" }}>{a.testName}</td>
                    <td style={{ color: "var(--gray-500)", fontSize: "0.82rem" }}>
                      {new Date(a.appointmentTime).toLocaleDateString("en-IN", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>
                    <td>
                      <span className={`cell-status ${statusClass(a.status)}`}>
                        {a.status}
                      </span>
                    </td>
                    <td>
                      <Link
                        to={`/appointments/appointment-details/${a._id}`}
                        style={{ fontSize: "0.8rem", color: "var(--primary)" }}
                      >
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
